import { createCustomEnum } from "./customEnum";

export type BooleanTypesKeys = "yes" | "no";

export const BooleanTypes = createCustomEnum({
	Yes: {
		name: "yes",
		value: "true",
		displayName: "Yes",
	},
	No: {
		name: "no",
		value: "false",
		displayName: "No",
	},
});

export default BooleanTypes;
